module.exports.rules = {
  vi: {
    title: 'Luật chơi Avalon: cách chơi, thiết lập và vai trò',
    description:
      'Tìm hiểu cách chơi Avalon với 5–10 người: chia vai, bỏ phiếu chọn Đội và bảng số người làm Nhiệm vụ. Xem điều kiện thắng và luật Ám sát Merlin.',
    keywords: ['Luật chơi Avalon', 'Cách chơi Avalon', 'Hướng dẫn'],
  },
  pt: {
    title: 'Regras de Avalon: como jogar, papéis e tabela de missões',
    description:
      'Como jogar The Resistance: Avalon com 5–10 pessoas: papéis, votos e tabela de missões. Entenda os três sucessos, o assassinato de Merlin e as variantes online.',
    keywords: ['Wiki', 'Regras', 'Como jogar'],
  },
  en: {
    title: 'Avalon Board Game Rules: How to Play, Setup & Roles',
    description:
      'How to play The Resistance: Avalon with 5–10 players: role setup, team voting and a mission-size table. Learn the win conditions and Merlin assassination.',
    keywords: ['Wiki', 'Rules', 'How to play'],
  },
  ru: {
    title: 'Авалон: правила настольной игры и роли на 5–10 человек',
    description:
      'Как играть в настольный Авалон на 5–10 человек: роли, голосование и таблица походов. Три успешные миссии, покушение на Мерлина и отличия онлайн-правил.',
    keywords: ['Вики', 'Правила', 'Как играть'],
  },
  'zh-TW': {
    title: '阿瓦隆規則：怎麼玩、5–10 人配置與任務人數表',
    description:
      '阿瓦隆怎麼玩？從組隊投票到任務與刺殺梅林，四步學會基本玩法。查看 5–10 人角色配置、任務人數表、兩張失敗牌的例外，以及原版桌遊與線上規則的差異。',
    keywords: ['維基', '規則', '玩法'],
  },
  'zh-CN': {
    title: '阿瓦隆规则：怎么玩、5–10 人配置与任务人数表',
    description:
      '阿瓦隆怎么玩？从组队投票到任务与刺杀梅林，四步学会基本玩法。查看 5–10 人角色配置、任务人数表、两张失败牌的例外，以及原版桌游与在线规则的区别。',
    keywords: ['维基', '规则', '怎么玩'],
  },
  es: {
    title: 'Avalon: reglas del juego de mesa, roles y cómo jugar',
    description:
      'Cómo jugar a The Resistance: Avalon con 5–10 personas: roles, votos y tabla de misiones. Consulta cómo ganar, el asesinato de Merlín y las variantes online.',
    keywords: ['Wiki', 'Reglas', 'Cómo jugar'],
  },
};
